"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const InputHolder = _styledComponents.default.div.withConfig({
  displayName: "Input__InputHolder",
  componentId: "design-system__j4qpdh-0"
})(["border:0;background:", ";position:relative;svg{width:21px;height:21px;position:absolute;top:50%;transform:translateY(-50%);fill:", ";}input{border:1px solid ", ";border-radius:", ";box-shadow:8px 0 0 ", " inset;margin:0;background:transparent;display:block;width:100%;font-size:", ";line-height:20px;padding:9px ", ";padding-left:", ";box-sizing:border-box;color:", ";font-family:", ";line-height:1;min-height:2.5rem;&[type=number]{", "}&::placeholder{color:", ";font-style:italic;}&:disabled{background-color:", ";}&:focus{outline:0;}}&.startIcon svg{left:", ";}&.startIcon input[type=\"text\"],&.startIcon input[type=\"number\"]{padding:", " ", " ", " 2.5rem;}&.endIcon svg{right:", ";}&.endIcon input[type=\"text\"]{padding:", " 2.5rem ", " ", ";}"], _BaseTheme.default.colors.white, _BaseTheme.default.colors.lightgray, props => props.error ? _BaseTheme.default.colors.red : 'rgb(204,204,204)', _BaseTheme.default.radius.regular, props => props.error ? _BaseTheme.default.colors.red : 'transparent', _BaseTheme.default.type.size.normal, _BaseTheme.default.distance.small, props => props.error ? _BaseTheme.default.distance.normal : _BaseTheme.default.distance.small, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.content, props => props.noSpin && "\n        &::-webkit-inner-spin-button, \n        &::-webkit-outer-spin-button { \n            -webkit-appearance: none;\n            margin: 0; \n        }\n      ", _BaseTheme.default.colors.lightgray, _BaseTheme.default.colors.inputDisabledGray, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.distance.normal, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.distance.normal);

const Input = _ref => {
  let {
    type,
    value,
    placeholder,
    id,
    className,
    disabled,
    error,
    startIcon,
    endIcon,
    name,
    register,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    onKeyUp,
    step,
    min,
    max,
    noSpin
  } = _ref,
      props = _objectWithoutProperties(_ref, ["type", "value", "placeholder", "id", "className", "disabled", "error", "startIcon", "endIcon", "name", "register", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "step", "min", "max", "noSpin"]);

  return /*#__PURE__*/_react.default.createElement(InputHolder, {
    className: "".concat(className, " ").concat(startIcon ? 'startIcon' : '', " ").concat(endIcon ? 'endIcon' : ''),
    error: error,
    noSpin: noSpin
  }, startIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: startIcon
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    type: type,
    value: value,
    placeholder: placeholder,
    id: id,
    disabled: disabled,
    error: error.toString(),
    ref: register,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    step: step,
    min: min,
    max: max
  }, props)), endIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: endIcon
  }));
};

Input.propTypes = {
  type: _propTypes.default.oneOf(['text', 'email', 'number', 'password', 'search', 'tel', 'url']),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  placeholder: _propTypes.default.string,
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  startIcon: _propTypes.default.string,
  endIcon: _propTypes.default.string,
  name: _propTypes.default.string,
  register: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyDown: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  step: _propTypes.default.string,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  noSpin: _propTypes.default.bool
};
Input.defaultProps = {
  value: undefined,
  type: 'text',
  placeholder: '',
  id: '',
  className: '',
  disabled: false,
  error: false,
  startIcon: undefined,
  endIcon: undefined,
  register: () => {},
  name: '',
  onBlur: () => {},
  onChange: () => {},
  onClick: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  onKeyUp: () => {},
  step: undefined,
  min: undefined,
  max: undefined,
  noSpin: false
};
var _default = Input;
exports.default = _default;